export const getContrastColor = (hexColor: string) => {
  // Convert hex color to RGB
  const red = parseInt(hexColor.slice(1, 3), 16) / 255;
  const green = parseInt(hexColor.slice(3, 5), 16) / 255;
  const blue = parseInt(hexColor.slice(5, 7), 16) / 255;

  // Apply gamma correction to RGB values
  const adjust = (color: number) =>
    color <= 0.03928 ? color / 12.92 : Math.pow((color + 0.055) / 1.055, 2.4);
  const luminance =
    0.2126 * adjust(red) + 0.7152 * adjust(green) + 0.0722 * adjust(blue);

  // Return black or white based on luminance
  return luminance > 0.5 ? '#000' : '#FFF';
};
